import $ from 'jquery';

const courseProgramCvAccordion = () => {
	const el = {
		main: '.mi-course-program-cv',
		card: '.mi-course-program-cv-card',
		heading: '.mi-course-program-cv-card-heading',
		content: '.mi-course-program-cv-card-content',
		activeClass: 'is-active',
	};

	if ($(el.main).length === 0) return;

	const init = () => {
		bindEvents();
	};

	const bindEvents = () => {
		$(el.main).on('click', el.heading, function (e) {
			if ($(e.target).closest('.mi-course-program-download-btn').length) {
				return;
			}

			const $card = $(this).closest(el.card);
			toggleCard($card);
		});
	};

	const openCard = ($card) => {
		$card.addClass(el.activeClass);
	};

	const closeCard = ($card) => {
		$card.removeClass(el.activeClass);
	};

	const toggleCard = ($card) => {
		const isActive = $card.hasClass(el.activeClass);
		isActive ? closeCard($card) : openCard($card);
	};

	init();

	return { openCard };
};

const seeFullProgrammeScroll = (accordion) => {
	const el = {
		trigger: '#seeFullProgramme',
		targetCard: '.mi-course-program-cv-card.mi-course-program',
	};

	if ($(el.trigger).length === 0) return;

	$(document).on('click', el.trigger, function (e) {
		e.preventDefault();

		const $target = $(el.targetCard);
		if ($target.length === 0) return;

		if (accordion && accordion.openCard) {
			accordion.openCard($target);
		} else {
			$target.addClass('is-active');
		}

		$target[0].scrollIntoView({ behavior: 'smooth' });
	});
};

try {
	const accordion = courseProgramCvAccordion();
	seeFullProgrammeScroll(accordion);
} catch (error) {
	console.error('courseProgramCvAccordion / seeFullProggrameScroll', error);
}
